module.exports = __webpack_public_path__ + "img/bookstore.dae3dff7.webp";